import * as React from "react";
import { useEffect } from "react";
import { Route, Routes, Navigate} from "react-router";
import Home from "./features/DataExtractionTool/Home/Home";
import { Layout } from "./features/DataExtractionTool/Home/Layout";
import Login from "./features/DataExtractionTool/Login/Login";
import LandingPage from "./features/LandingPage/LandingPage";
import DataExtractionToolRoutes from "./features/DataExtractionTool/DataExtractionToolRoutes";
import AHPRAValidationToolRoutes from "./features/AHPRAValidationTool/AHPRAValidationToolRoutes";
import ChiesiRoutes from "./features/Chiesi/ChiesiRoutes";
import Request from "./features/DataExtractionTool/Request/Request";
import Report from "./features/DataExtractionTool/Report/Report";
import { useDispatch, useSelector } from "react-redux";
import { getUserDetails, updateAuthorized } from "./features/DataExtractionTool/Authentication/authenticationSlice";
import { eventEmitter } from "./api/eventEmitter";
// import { useHistory} from "react-router-dom";
import { useNavigate } from "react-router-dom";

import "./custom.css";

export default () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { user, isAuthorised } = useSelector((state) => state.authentication);

  useEffect(() => {
    dispatch(getUserDetails({ method: "GET" }));
  }, [dispatch]);

  useEffect(() => {
    if (isAuthorised && !user.userEmail) {
      navigate("/Login");
    }
  }, [user]);

  // Global event listener for unauthorized access
  useEffect(() => {
    const handleUnauthorized = () => {
      dispatch(updateAuthorized(false));
      navigate("/");
    };

    eventEmitter.on('unauthorized', handleUnauthorized);

    return () => {
      eventEmitter.off('unauthorized', handleUnauthorized);
    };
  }, [dispatch, navigate]);
  const ProtectedRoute = ({ children }) => {
    // const { user } = useSelector((state) => state.login);
 
    // if ( !user) {
    //   return <Navigate to="/" />;
    // }
    // if (!isAuthorised) {
    //   navigate("/Login");
    // }
    return children;
  };
  return (
    <div>

      <Routes>
        <Route exact path="/Login" element={<Login />} />
        <Route exact path="/" element={<Login />} />
        <Route exact path="/offerings" element={<LandingPage />} />

        <Route
          path="/data-extraction-tool/*"
          element={
            <React.Suspense fallback={<div>Loading...</div>}>
              <DataExtractionToolRoutes />
            </React.Suspense>
          }
        />

        <Route
          path="/ahpra-validation-tool/*"
          element={
            <React.Suspense fallback={<div>Loading...</div>}>
              <AHPRAValidationToolRoutes />
            </React.Suspense>
          }
        />
         
        <Route
          path="/custome-rmatch-portal/*"
          element={
            <React.Suspense fallback={<div>Loading...</div>}>
              <ChiesiRoutes />
            </React.Suspense>
          }
        />
      </Routes>
      
      
    </div>
  );
};
